import { helper } from '@ember/component/helper';
import {
  getWarehouseDestinationImageSrc,
  getWarehouseDestinationName,
  WarehouseDestination,
  getWarehouseDocumentationUrl,
} from 'cio/utils/warehouse';

export function warehouseInfo([detail, type]: ['imageSrc' | 'name', WarehouseDestination]) {
  return {
    imageSrc: getWarehouseDestinationImageSrc(type),
    name: getWarehouseDestinationName(type),
    documentationUrl: getWarehouseDocumentationUrl(type),
  }[detail];
}

export default helper(warehouseInfo);
